import { create } from "zustand";

const guestInfoInitialState = [
  {
    id: crypto.randomUUID(),
    firstName: "",
    lastName: "",
  },
];

const contactInfoInitialState = {
  email: "",
  phone: "",
  relationship: "",
  side: "",
  seatOrTable: "",
};

const useGuestListStore = create((set) => ({
  open: false,
  setOpen: (open) => set({ open }),

  loading: false,
  setLoading: (loading) => set({ loading }),

  guestList: [],
  setGuestList: (guestList) => set({ guestList }),

  isAddingGuest: false,
  setIsAddingGuest: (isAddingGuest) => set({ isAddingGuest }),

  isDeletingGuest: false,
  setIsDeletingGuest: (isDeletingGuest) => set({ isDeletingGuest }),

  selectedGuest: null,
  setSelectedGuest: (selectedGuest) => set({ selectedGuest }),

  mutatedGuestInfo: guestInfoInitialState,
  setMutatedGuestInfo: (mutatedGuestInfo) => set({ mutatedGuestInfo }),

  mutatedContactInfo: contactInfoInitialState,
  setMutatedContactInfo: (mutatedContactInfo) => set({ mutatedContactInfo }),

  returnToView: () =>
    set({
      isAddingGuest: false,
      isDeletingGuest: false,
      selectedGuest: null,
      mutatedGuestInfo: [
        {
          id: crypto.randomUUID(), // need to generate uuid so we rerender
          firstName: "",
          lastName: "",
        },
      ],
      mutatedContactInfo: contactInfoInitialState,
    }),

  resetMutatedGuest: () =>
    set({
      mutatedGuestInfo: [
        {
          id: crypto.randomUUID(), // need to generate uuid so we rerender
          firstName: "",
          lastName: "",
        },
      ],
      mutatedContactInfo: contactInfoInitialState,
      selectedGuest: null,
    }),
}));

export default useGuestListStore;
